import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { TonnageInputModel } from '../../Tonnage/reducers/TonnageInputReducer';

interface tonnageQuickInputState {
    tonnageInput: TonnageInputModel,
    selectedTonnageId: string,
    triggerFocusTonnageNameQuickInput: number,
    triggerSave: number,
    triggerRefreshInput: number
}

const initialState: tonnageQuickInputState = {
    tonnageInput: {
        id: "",
        headOwner: "",
        operator: "",
        vesselName: "",
        dwt: null,
        yearBuilt: null,
        portOpen: 0,
        dateOpenStart: "",
        dateOpenEnd: "",
        remarks: "",
        gear: null,
        draft: null,
        loa: null,
        class: "",
        beam: null,
        grabs: false,
        fullTc: "",
        deck: "",
        capacity: null,
        updateFullTc: false
    } as TonnageInputModel,
    selectedTonnageId: "",
    triggerFocusTonnageNameQuickInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0
}

export const TonnageQuickInputSlice = createSlice({
    name: "TonnageQuickInput",
    initialState,
    reducers: {
        resetTonnageInput: (state) => {
            state.tonnageInput = initialState.tonnageInput;
        },
        setTonnageInput: (state, action: PayloadAction<TonnageInputModel>) => {
            state.tonnageInput = action.payload;
        },
        setTonnageInputId: (state, action: PayloadAction<string>) => {
            state.tonnageInput.id = action.payload;
        },
        setVesselName: (state, action: PayloadAction<string>) => {
            state.tonnageInput.vesselName = action.payload;
        },
        setPortOpen: (state, action: PayloadAction<number>) => {
            state.tonnageInput.portOpen = action.payload;
        },
        setDateOpenStart: (state, action: PayloadAction<string>) => {
            state.tonnageInput.dateOpenStart = action.payload;
        },
        setDateOpenEnd: (state, action: PayloadAction<string>) => {
            state.tonnageInput.dateOpenEnd = action.payload;
        },
        setSelectedTonnageId: (state, action: PayloadAction<string>) => {
            state.selectedTonnageId = action.payload;
        },
        setTriggerFocusTonnageNameQuickInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusTonnageNameQuickInput = action.payload;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
    }
});

export const tonnageQuickInputSelector = createSelector(
    (state: RootState) => state.tonnageQuickInput,
    (data) => data
);

export const {
    resetTonnageInput,
    setTonnageInput,
    setTonnageInputId,
    setVesselName,
    setPortOpen,
    setDateOpenStart,
    setDateOpenEnd,
    setSelectedTonnageId,
    setTriggerFocusTonnageNameQuickInput,
    setTriggerSave,
    setTriggerRefreshInput
} = TonnageQuickInputSlice.actions;

export default TonnageQuickInputSlice.reducer;